import { KlaviyoPopupAdapter } from '@/components/popup-logic/adapters/klaviyo';
import { Popup } from '@/components/popup-logic/popup';

type KlaviyoIDs = {
  displayName: string;
  desktop: string;
  mobile: string;
};

export default function addDefinitions(): boolean {
  try {
    // Don't run on Medispa pages
    if (
      document.body.classList.contains('template-medispa-v2') ||
      window?.PDP?.productData?.vendor.toLowerCase().indexOf('medispa') !== -1
    ) {
      return false;
    }

    // Don't run on voucher page
    if (window.location.href.includes('/products/glamour-beauty-affairs-700-voucher')) {
      return false;
    }

    // Map of popup IDs to their desktop and mobile variants
    // Key is the market code (e.g. "zh-hans", "en"). "default" is used as a fallback
    const klaviyoFormMap = new Map<string, KlaviyoIDs>([
      [
        'zh-hans',
        {
          displayName: 'One-step email & SMS - Simplified Chinese',
          desktop: 'YbaXqU',
          mobile: 'Rd6GhH',
        },
      ],
      [
        'en',
        {
          displayName: 'One-step email & SMS - English',
          desktop: 'Rf56aB',
          mobile: 'YnD823',
        },
      ],
      [
        'default',
        {
          displayName: 'One-step email & SMS - Traditional Chinese',
          desktop: 'RLiYCK',
          mobile: 'SiGLTY',
        },
      ],
    ]);

    const currentMarket = window.Shopify.routes.root.replace(/\//g, '');

    const klaviyoID = klaviyoFormMap.get(currentMarket) || klaviyoFormMap.get('default')!;

    // After all those checks are done, if the popup config has been overridden, use those IDs instead

    if (typeof window.offerPopupConfig?.override_source !== 'undefined') {
      klaviyoID.desktop = window.offerPopupConfig.desktop;
      klaviyoID.mobile = window.offerPopupConfig.mobile;
    }

    const deviceType = matchMedia('(pointer: fine)').matches ? 'desktop' : 'mobile';

    const adapter = new KlaviyoPopupAdapter({ id: klaviyoID[deviceType] });
    const popup = new Popup(adapter, {
      id: klaviyoID[deviceType],
      displayName: klaviyoID.displayName,
    });

    window.popupMonitor.addPopup(popup);

    return true;
  } catch (e) {
    console.error(e);
    return false;
  }
}
